import React, { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import EyeIcon from 'mdi-react/EyeIcon';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import PropTypes from 'prop-types';
import setPropsAsInitialValues from '../../../helpers/setPropsAsInitialValues';
import TextBox from '../../../shared/components/form/TextBox';
import validate from './validate';

class FirstLogIn extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    isResetMode: PropTypes.bool,
  };

  static defaultProps = {
    isResetMode: false,
  };

  constructor() {
    super();
    this.state = { showPassword: false };
  }

  showPassword = (e) => {
    e.preventDefault();
    const { currentTarget: { id } } = e;
    this.setState(prevState => ({ [id]: !prevState[id] }));
  }

  render() {
    const { showPassword, showNewPassword, showNewPasswordConfirmation } = this.state;
    const {
      handleSubmit, submitting, pristine, isResetMode,
    } = this.props;

    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">Usuario</span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <AccountOutlineIcon />
            </div>
            <Field
              name="email"
              component={TextBox}
              type="text"
              placeholder="Email"
              disabled
            />
          </div>
        </div>

        {!isResetMode && (
          <div className="form__form-group">
            <span className="form__form-group-label">Contrase&ntilde;a actual</span>
            <div className="form__form-group-field">
              <div className="form__form-group-icon">
                <KeyVariantIcon />
              </div>
              <Field
                name="password"
                component={TextBox}
                type={showPassword ? 'text' : 'password'}
                placeholder="Contrase&ntilde;a actual"
              />
              <button
                id="showPassword"
                className={`form__form-group-button${showPassword ? ' active' : ''}`}
                onClick={e => this.showPassword(e)}
                type="button"
                tabIndex={0}
              ><EyeIcon />
              </button>
            </div>
          </div>
        )}

        <div className="form__form-group">
          <span className="form__form-group-label">Contrase&ntilde;a nueva</span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <KeyVariantIcon />
            </div>
            <Field
              name="newPassword"
              component={TextBox}
              type={showNewPassword ? 'text' : 'password'}
              placeholder="Contrase&ntilde;a nueva"
            />
            <button
              id="showNewPassword"
              className={`form__form-group-button${showNewPassword ? ' active' : ''}`}
              onClick={e => this.showPassword(e)}
              type="button"
              tabIndex={0}
            ><EyeIcon />
            </button>
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">Confirmaci&oacute;n de ontrase&ntilde;a nueva</span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <KeyVariantIcon />
            </div>
            <Field
              name="newPasswordConfirmation"
              component={TextBox}
              type={showNewPasswordConfirmation ? 'text' : 'password'}
              placeholder="Confirmaci&oacute;n de ontrase&ntilde;a nueva"
            />
            <button
              id="showNewPasswordConfirmation"
              className={`form__form-group-button${showNewPasswordConfirmation ? ' active' : ''}`}
              onClick={e => this.showPassword(e)}
              type="button"
              tabIndex={0}
            ><EyeIcon />
            </button>
          </div>
        </div>
        <button
          type="submit"
          className="btn btn-primary account__btn account__btn--small"
          disabled={pristine || submitting}
        >Establecer nueva contrase&ntilde;a
        </button>
      </form>
    );
  }
}

const FirstLogInForm = reduxForm({
  form: 'LogInForm',
  enableReinitialize: true,
  validate,
})(FirstLogIn);

export default setPropsAsInitialValues(FirstLogInForm);
